import Vue from 'vue'
import Vuex from 'vuex'
import services from '@/services'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    visions: {
      overview: {},
      map: [],
      charts: {},
      prefectures: [],
      update: {},
    },
  },
  mutations: {
    setVisions (state, visions) {
      state.visions = visions
    },
  },
  actions: {
    async fetchVisions ({ commit }) {
      let visions = await services.getVisions()
      commit('setVisions', visions)
    },
  },
})

export default store
